// Possible actions to take on those shareable items within the open item modal
export var OpenItemModalAction;
(function (OpenItemModalAction) {
    OpenItemModalAction["SELECT"] = "select";
    OpenItemModalAction["EDIT"] = "edit";
    OpenItemModalAction["DELETE"] = "delete";
})(OpenItemModalAction || (OpenItemModalAction = {}));
